// @ts-nocheck
import { useState } from 'react';
import styled from 'styled-components';
import colors from '../../../../styles/colors';
import GenericRenderContainerSection from '../../SingleWrestlerPage/GenericRenderContainerSection';
import RenderFightInsideBoxComponent from '../../Matches/RenderFightInsideBoxComponent';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';

const FightCardContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 90%;
    height: ${props => props.isExpanded ? '120px' : '100px'};
    border: 2px solid white;
    border-radius: 5px;
    color: white;
    background-color: ${colors.bgColorBordeaux};
    padding: 15px 5px 5px 5px;
    margin: 10px 0;
    flex-shrink: 0;
    transition: all 0.3s ease;
    
    & h2 {
        font-size: 12px;
        font-weight: 600;
        text-align: center;
        margin: 0;
        padding: 0;
    }
`

function BoxListMatchMobileComponent({ listMatch }) {
    const [expandedMatches, setExpandedMatches] = useState({});

    const handleClick = (matchId) => {
        setExpandedMatches(prev => ({
            ...prev,
            [matchId]: !prev[matchId]
        }));
    };

    const renderFight = (match, key) => {
        const isExpanded = expandedMatches[match.id] || false;
        
        return (
            <FightCardContainer 
             key={key} 
             className='fight-card-container'
             isExpanded={isExpanded}
             onClick={() => handleClick(match.id)}
            >
                <TopDecorColor 
                 className='top-decor-color'
                 height = '10px' 
                />
                <RenderFightInsideBoxComponent 
                 fight={match} 
                 withWinner={true} 
                 isExpanded={isExpanded}
                />
            </FightCardContainer>
        )
    }

    return (
        <GenericRenderContainerSection
         className='box-list-match-mobile-component'
         width="95%"
         padding="10px 0"
        >
            {/* Ciclo i match e renderizzo il match */}
            {listMatch.map((match, key) => (
                renderFight(match, key)
            ))}

        </GenericRenderContainerSection>

    )
}

export default BoxListMatchMobileComponent;